import { Reveal } from "./motion";
import { ArrowUpRight } from "lucide-react";
import { useConversion } from "../context/BookingContext";
import { SERVICES } from "../data";

export default function Services() {
  const { openBooking, openQuote } = useConversion();

  return (
    <section id="services" data-testid="services" className="bg-[#030303] py-20 md:py-32">
      <div className="max-w-[1600px] mx-auto px-5 md:px-10">
        <Reveal>
          <p className="text-xs tracking-[0.3em] uppercase text-[#FF3B30] mb-4">What we do</p>
          <h2 className="font-display font-bold uppercase tracking-tight text-4xl md:text-6xl leading-none max-w-3xl">
            Four services. One obsession with the finish.
          </h2>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-px bg-zinc-800 border border-zinc-800">
          {SERVICES.map((s, i) => (
            <Reveal key={s.key} delay={i * 0.08}>
              <div
                data-testid={`service-card-${s.key}`}
                onClick={() => (s.path === "quote" ? openQuote(s.title) : openBooking())}
                className="group relative bg-[#0A0A0A] overflow-hidden cursor-pointer h-full min-h-[420px] flex flex-col justify-end"
              >
                <div className="absolute inset-0 overflow-hidden">
                  <img src={s.image} alt={s.title} className="w-full h-full object-cover opacity-40 group-hover:opacity-60 group-hover:scale-105 transition-all duration-700" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
                </div>
                <div className="relative p-7 md:p-9">
                  <div className="flex items-start justify-between">
                    <div>
                      <p className="text-[11px] tracking-[0.2em] uppercase text-zinc-500 mb-2">
                        {s.path === "quote" ? "Quote request" : "Instant book"}
                      </p>
                      <h3 className="font-display font-bold uppercase tracking-tight text-3xl md:text-4xl group-hover:text-[#FF3B30] transition-colors duration-300">{s.title}</h3>
                    </div>
                    <ArrowUpRight className="text-white group-hover:text-[#FF3B30] group-hover:rotate-45 transition-all duration-300 shrink-0" size={28} strokeWidth={1.5} />
                  </div>
                  <p className="text-zinc-300 mt-4 max-w-md">{s.line}</p>
                  <p className="text-zinc-500 text-sm mt-2 max-w-md">{s.detail}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
